module.exports = __webpack_public_path__ + "static/img/product_1_2.8b91c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_2.png
// module id = ekdt
// module chunks = 34